import { fetchQuery } from '@/services/messaging/fetchQuery';

export function get2FactorAuthenticationSettingsConfiguration() {
  return fetchQuery("Get2FactorAuthenticationSettingsConfiguration", {});
}
